import Table from "./Table";
import { EmissionsSourceSummary } from "../api/models/EmissionsSource";
import {
    confidenceNameToRagMap,
    colourToBgClassMap,
    dataStatusNameToColourMap,
    ragToBgClassMap,
} from "../constants";
import clsx from "clsx";

export type EmissionSourcesTableProps = {
    onRowClick: (id: number) => void;
    emissionSources: EmissionsSourceSummary[];
    orderBy?: string;
    onOrderBy: (orderBy: string) => void;
    sortOrder?: string;
};

const MaterialEmissionsSourcesTable = ({
    onRowClick,
    emissionSources,
    orderBy,
    sortOrder,
    onOrderBy,
}: EmissionSourcesTableProps) => {
    return (
        <Table
            className="!min-w-[1200px]"
            headings={[
                { label: "Unique Reference", orderByKey: "UniqueReference" },
                {
                    label: "Name",
                    orderByKey: "Name",
                },
                { label: "Location", orderByKey: "LocationName" },
                { label: "Category", orderByKey: "CategoryName" },
                { label: "Type", orderByKey: "TypeName" },
                { label: "Item", orderByKey: "ItemName" },
                { label: "Scope", orderByKey: "Scope" },
                { label: "EF Confidence" },
                { label: "Data Status" },
                { label: "Kg CO2e" },
            ]}
            data={emissionSources}
            renderRowCells={(rowData) => (
                <>
                    <td className="min-w-[35px]">{rowData.uniqueReference}</td>
                    <td>{rowData.name}</td>
                    <td>{rowData.locationName}</td>
                    <td>{rowData.categoryName}</td>
                    <td>{rowData.typeName}</td>
                    <td>{rowData.itemName}</td>
                    <td>{rowData.scope}</td>
                    <td className="min-w-[35px]">
                        {["MeasuredSecondary", "MeasuredPrimary"].includes(
                            rowData.dataStatusName
                        ) ? (
                            <div className="flex items-center space-x-3">
                                <div
                                    className={clsx(
                                        "text-white text-center rounded-md text-xs py-1 px-3",
                                        rowData.dataSourceEmissionsFactorConfidenceName
                                            ? ragToBgClassMap[
                                                  confidenceNameToRagMap[
                                                      rowData
                                                          .dataSourceEmissionsFactorConfidenceName
                                                  ]
                                              ]
                                            : ragToBgClassMap["red"]
                                    )}
                                >
                                    {rowData.dataSourceEmissionsFactorConfidenceName ??
                                        "Missing"}
                                </div>
                            </div>
                        ) : (
                            <>-</>
                        )}
                    </td>
                    <td className="min-w-[45px]">
                        <div className="flex items-center space-x-3">
                            <div
                                className={clsx(
                                    "text-white text-center rounded-md text-xs py-1 px-3",
                                    colourToBgClassMap[
                                        dataStatusNameToColourMap[
                                            rowData.dataStatusName
                                        ]
                                    ]
                                )}
                            >
                                {[
                                    "MeasuredSecondary",
                                    "MeasuredPrimary",
                                ].includes(rowData.dataStatusName) ? (
                                    rowData.dataStatusName ===
                                    "MeasuredSecondary" ? (
                                        "Measured - Secondary"
                                    ) : (
                                        "Measured - Primary"
                                    )
                                ) : (
                                    <>{rowData.dataStatusName}</>
                                )}
                            </div>
                        </div>
                    </td>
                    <td>
                        {["MeasuredSecondary", "MeasuredPrimary"].includes(
                            rowData.dataStatusName
                        ) ? (
                            rowData.activityDataCo2eKgInPeriod.toLocaleString()
                        ) : (
                            <>-</>
                        )}
                    </td>
                </>
            )}
            onRowClick={(rowData) => onRowClick(rowData.id)}
            orderBy={orderBy}
            sortOrder={sortOrder}
            onOrderBy={onOrderBy}
        />
    );
};

export default MaterialEmissionsSourcesTable;
